import React, { useState, useEffect } from 'react';
import { Dropdown, Container } from 'react-bootstrap';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { DEPARTMENTS } from '../utils/departments';
import CartDrawer from './CartDrawer';
import api from '../services/api';
import './SiteNavbar.css';

const GridIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
    <path d="M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5v-3zm8 0A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5v-3zm-8 8A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5v-3zm8 0A1.5 1.5 0 0 1 10.5 9h3A1.5 1.5 0 0 1 15 10.5v3A1.5 1.5 0 0 1 13.5 15h-3A1.5 1.5 0 0 1 9 13.5v-3z"/>
  </svg>
);

const ChevronIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16" className="chev">
    <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
  </svg>
);

const CartIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16">
    <path d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .49.598l-1.5 7A.5.5 0 0 1 13 11H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5zM3.102 4l1.313 6.5h8.17L13.898 4H3.102zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zM6 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
  </svg>
);

const SearchIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.44.06.783.404l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.8-.388zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"/>
  </svg>
);

const HamburgerIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16">
    <path fillRule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
  </svg>
);

export default function SiteNavbar() {
  const { totalItems } = useCart();
  const [showCart, setShowCart] = useState(false);
  const [open, setOpen] = useState(false);
  const [customer, setCustomer] = useState(null);
  const [term, setTerm] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const raw = sessionStorage.getItem('customerUser');
    if (raw) {
      try { setCustomer(JSON.parse(raw)); } catch (_) { setCustomer(null); }
    }
  }, []);

  // Mantém o campo preenchido ao chegar na página de busca por link ou pelo
  // botão voltar, e o esvazia ao sair dela.
  useEffect(() => {
    const q = new URLSearchParams(location.search).get('q') || '';
    setTerm(location.pathname === '/busca' ? q : '');
  }, [location.pathname, location.search]);

  const handleSearch = (e) => {
    e.preventDefault();
    const q = term.trim();
    if (!q) return;
    setOpen(false);
    navigate(`/busca?q=${encodeURIComponent(q)}`);
  };

  const handleLogout = () => {
    api.post('/auth/logout').catch(() => {});
    sessionStorage.removeItem('customerToken');
    sessionStorage.removeItem('customerUser');
    localStorage.removeItem('customerRefreshToken');
    setCustomer(null);
    navigate('/');
  };

  const firstName = customer?.name?.split(' ')[0] || '';
  const initial = (customer?.name || '?').trim().charAt(0).toUpperCase();

  return (
    <>
      <div className="topbar-info">
        <Container>
          <div className="topbar-inner">
            <span className="topbar-msg">
              {/*
              <TruckIcon />
              <span className="topbar-accent">Frete grátis</span> em compras acima de R$ 199
              */}
            </span>
            
            <span className="topbar-links">
              <Link to="/quem-somos">Quem somos</Link>
              <Link to="/trocas-e-devolucoes">Trocas e devoluções</Link>
              <Link to="/politica-de-privacidade">Privacidade</Link>
            </span>
          </div>
        </Container>
      </div>

      <nav className="site-navbar">
        <Container>
          <div className="navbar-inner">
            <Link to="/" className="site-brand">
              <img src="/imagens/logo.jpeg" alt="Wilboor" />
              <span className="site-brand-text">
                <span className="brand-name">Wilboor</span>
                <span className="brand-tag">Loja Online</span>
              </span>
            </Link>

            <form className="site-search" role="search" onSubmit={handleSearch}>
              <span className="site-search-icon"><SearchIcon /></span>
              <input
                type="search"
                className="site-search-input"
                placeholder="Buscar produtos pelo nome..."
                aria-label="Buscar produtos pelo nome"
                value={term}
                onChange={(e) => setTerm(e.target.value)}
              />
              <button type="submit" className="site-search-btn">Buscar</button>
            </form>

            <button
              type="button"
              className="site-toggle"
              aria-label="Abrir menu"
              onClick={() => setOpen(o => !o)}
            >
              <HamburgerIcon />
            </button>

            <div className={`navbar-collapsible ${open ? 'open' : ''}`}>
              <Dropdown>
                <Dropdown.Toggle as="button" className="dept-toggle">
                  <GridIcon />
                  Departamentos
                  <ChevronIcon />
                </Dropdown.Toggle>
                <Dropdown.Menu className="site-dropdown-menu">
                  {DEPARTMENTS.map(dept => (
                    <Dropdown.Item
                      key={dept.slug}
                      as={Link}
                      to={`/departamento/${dept.slug}`}
                    >
                      {dept.name}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>

              <div className="site-actions">
                {customer ? (
                  <Dropdown align="end">
                    <Dropdown.Toggle as="button" className="user-toggle">
                      <span>Olá, {firstName}</span>
                      <span className="user-avatar">{initial}</span>
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="site-dropdown-menu">
                      <Dropdown.Item disabled style={{ fontSize: '0.78rem', color: '#888' }}>
                        {customer.email}
                      </Dropdown.Item>
                      <Dropdown.Divider />
                      <Dropdown.Item as={Link} to="/minha-conta">Minha conta</Dropdown.Item>
                      <Dropdown.Item onClick={handleLogout}>Sair da conta</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                ) : (
                  <>
                    <Link to="/login" className="btn-pill btn-pill-ghost">Entrar</Link>
                    <Link to="/cadastro" className="btn-pill btn-pill-dark">Cadastrar</Link>
                  </>
                )}

                <button
                  onClick={() => setShowCart(true)}
                  aria-label="Abrir carrinho"
                  className="cart-button"
                >
                  <CartIcon />
                  {totalItems > 0 && <span className="cart-badge">{totalItems}</span>}
                </button>
              </div>
            </div>
          </div>
        </Container>
      </nav>

      <CartDrawer show={showCart} onHide={() => setShowCart(false)} />
    </>
  );
}
